export class DareDropApiError extends Error {
    constructor({ errorMessage, cause, statusCode }) {
        super(errorMessage, { cause });
        this.statusCode = statusCode !== null && statusCode !== void 0 ? statusCode : 0;
    }
}
